import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MDS_TRANSLATE_LOADERS, provideMdsTranslation, provideMdsTranslationLocale } from '@mds/ngx-core';
import { LayoutTranslationLoader } from '@mds/ngx-layout';
import { WebpackTranslateLoader } from '../config/translate-loader';

export function provideTranslations(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: MDS_TRANSLATE_LOADERS, useClass: WebpackTranslateLoader, multi: true },
    { provide: MDS_TRANSLATE_LOADERS, useClass: LayoutTranslationLoader, multi: true },
    provideMdsTranslation(),
    provideMdsTranslationLocale(),
  ]);
}
